import { connect } from 'react-redux';

import { createQuestion } from '@/features/questionCreatePage/actions';

import NewQuestion from './component';

const mapDispatchToProps = { createQuestion };

export default connect(null, mapDispatchToProps)(NewQuestion);
